var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"channel-nextProgram border-left"},[_c('channelProgram',{directives:[{name:"show",rawName:"v-show",value:(_vm.nextProgram),expression:"nextProgram"}],staticClass:"flex-grow-1",attrs:{"data":_vm.nextProgram,"humanize":true,"time":true,"background":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }